import axios from 'axios';
import { API_BASE_URL } from '../config';

/**
 * Centralized API client with automatic authentication.
 *
 * Usage:
 *   import api from '../services/api';  (adjust path as needed)
 *   const res = await api.get('/reflections');
 *   await api.post('/reflections', { promptId: 1 });
 *
 * The Authorization header is automatically added from localStorage.
 * For file uploads, just pass FormData — Content-Type is set automatically by axios.
 */
const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
